export default [
  'Program',
  'Project',
  'dbGaP Study ID',
  'Total Expected Aliquots',
  'Total Aliquot in GDC',
  'Total Aliquots with a valid data file',
  'Normal Aliquots with a valid data file',
  'Tumor Aliquots with a valid data file',
  'Abnormal Aliquots with a valid data file',
  'Peritumoral Aliquots with a valid data file',
];
